module.exports = __webpack_public_path__ + "img/front.cbd6f67e.png";